import { Poppins } from 'next/font/google';
import localFont from 'next/font/local';

export const poppins = Poppins({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
  display: 'swap',
  variable: '--font-poppins',
});

export const lemonYellow = localFont({
  src: [
    {
      path: '../../public/fonts/LemonYellowSunBold/font.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  variable: '--font-lemon-yellow',
  display: 'swap',
  preload: true,
});

export const fontVariablesClassName = `${poppins.variable} ${lemonYellow.variable}`;
